// Dust threshold: positions with holdings value below this are considered "dust"
// and can be hidden from the UI. This threshold is shared across the application
// and matches the backend default in internal/pf/domain/mover_notification.go
export const DUST_THRESHOLD_USD = 20;
